// apps/web/src/lib/material-atributos.ts
import type { MaterialAtributosProcesso, TipoTinta, TipoBanho } from '@pieltec/contracts';

export function rotuloBanho(banho: TipoBanho | null | undefined): string | null {
  if (!banho) return null;
  switch (banho) {
    case 'ACO': return 'AÇO';
    case 'ALUMINIO': return 'ALU';
    case 'JATEAMENTO': return 'JATO';
    default: return banho;
  }
}

export function rotuloTinta(tinta: TipoTinta | null | undefined): string | null {
  if (!tinta) return null;
  switch (tinta) {
    case 'PO': return 'PÓ';
    case 'LIQUIDA': return 'LÍQ';
    case 'PTFE': return 'PTFE';
    default: return tinta;
  }
}

export function atributosIncompletos(material: Pick<MaterialAtributosProcesso, 'pinta' | 'tipoTinta' | 'corFamilia' | 'porte' | 'exigeIsolamento'>): boolean {
  if (!material.pinta) return false;
  return (
    material.tipoTinta === null || material.tipoTinta === undefined ||
    material.corFamilia === null || material.corFamilia === undefined ||
    material.porte === null || material.porte === undefined ||
    material.exigeIsolamento === null || material.exigeIsolamento === undefined
  );
}

export function camposProcessoPendentes(material: { pinta?: boolean; tipoTinta?: string | null; corFamilia?: string | null; porte?: string | null; exigeIsolamento?: boolean | null }): string[] {
  if (!material.pinta) return [];
  return [
    material.tipoTinta == null ? 'Tipo de tinta' : null,
    material.corFamilia == null ? 'Família da cor' : null,
    material.porte == null ? 'Porte' : null,
    material.exigeIsolamento == null ? 'Exige isolamento (Sim ou Não)' : null,
  ].filter((campo): campo is string => campo !== null);
}

export const opcoesFamiliaCor = [
  { value: 'CLARA', label: 'Clara' },
  { value: 'ESCURA', label: 'Escura' },
  { value: 'PRETA', label: 'Preta' },
  { value: 'CINZA', label: 'Cinza' },
];

export const opcoesPorte = [
  { value: 'PEQUENA', label: 'Pequena' },
  { value: 'QUALQUER', label: 'Qualquer tamanho' },
];

export const opcoesBanho = [
  { value: 'ACO', label: 'Aço' },
  { value: 'ALUMINIO', label: 'Alumínio' },
  { value: 'JATEAMENTO', label: 'Jateamento' },
];

export const opcoesTinta = [
  { value: 'PO', label: 'Pó' },
  { value: 'LIQUIDA', label: 'Líquida' },
  { value: 'PTFE', label: 'PTFE' },
];
